export enum MessageType {
  Error,
  Warning,
  Success,
  Informational,
}
